import React from "react";
import { withNamespaces } from "react-i18next";

const NotFound = ({ t }) => {
  return <h1>{t("validation.404")}</h1>;
};

export default withNamespaces()(NotFound);
